import type { PostFunctionsDrofusArticlesDetailsApiResponse } from "../../openapi";

export function formatArticleValue(value: unknown): string {
  if (value == null || value === "") return "–";
  if (typeof value === "boolean") return value ? "Ja" : "Nei";
  if (typeof value === "object") return JSON.stringify(value, null, 2);
  return String(value);
}
export function articleFieldGroups(data: PostFunctionsDrofusArticlesDetailsApiResponse | undefined, search: string) {
  if (!data?.article) return [];
  const fields = new Map(data.fields.map(field => [field.id, field]));
  for (const id of Object.keys(data.article)) {
    if (!fields.has(id)) fields.set(id, { id, name: id, propertyGroup: "Andre felt", dataType: "" });
  }
  const groups = new Map<string, { id: string; label: string; value: string; unit: string }[]>();
  const query = search.trim().toLocaleLowerCase();
  for (const field of fields.values()) {
    const group = field.propertyGroup || "Generelt";
    const value = formatArticleValue(data.article[field.id]);
    if (query && !`${group} ${field.name} ${field.id} ${value}`.toLocaleLowerCase().includes(query)) continue;
    const rows = groups.get(group) ?? [];
    rows.push({ id: field.id, label: field.name, value, unit: field.unit && field.unit !== "Undefined" ? field.unit : "" });
    groups.set(group, rows);
  }
  return Array.from(groups, ([name, rows]) => ({ name, rows }));
}
